import type { WorkitemTag } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { useLiveQuery } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'
import { getWorkitemTagsCollection } from '../contexts'

export function useWorkitemTagsByTeam(teamId: string | null | undefined): UseLiveQueryReturn<WorkitemTag> | undefined {
  const logger = useRhythmicLogger('useWorkitemsByTeamId')

  if (!teamId || teamId === null || teamId === undefined || teamId === '') {
    logger.debug('Skipping workitems query: missing teamId')
    return undefined
  }

  const collection = getWorkitemTagsCollection(teamId)

  const query = useLiveQuery((builder) => builder.from({ w: collection }))

  return query
}
